import {
  LoginFormData,
  OTPCodeReqBody,
  PostLoginRes,
  PostRefreshTokenRes,
  RecaptchaReqBody,
  RecaptchaRes,
} from './types';
import { KStadiumInstance } from '../../instance';
import { setTokenInLocalStorage } from '../../../storage/token';

const SUB_URL = `/member/login`;

export const logIn = async (loginRequestBody: LoginFormData) =>
  KStadiumInstance.post<PostLoginRes>(
    `${SUB_URL}/login`,
    loginRequestBody,
  ).then((res) => res.data);

export const requestRefreshToken = () =>
  KStadiumInstance.post<PostRefreshTokenRes>(`${SUB_URL}/refresh`).then(
    ({ data }) => {
      setTokenInLocalStorage(data.data);
      return data.data;
    },
  );

export const logInOTP = async (OTPCode: OTPCodeReqBody) =>
  KStadiumInstance.post<PostLoginRes>(`${SUB_URL}/2fa/bridge`, OTPCode, {
    headers: {
      'X-AUTH-MOBILE': false,
    },
  }).then((res) => res.data);

export const confirmOTP = async (OTPCode: OTPCodeReqBody) =>
  KStadiumInstance.post<PostLoginRes>(`${SUB_URL}/2fa/bridge/otp`, OTPCode, {
    headers: {
      'X-AUTH-MOBILE': false,
    },
  }).then((res) => res.data);

export const confirmRecaptcha = async (recaptchaToken: RecaptchaReqBody) =>
  KStadiumInstance.post<RecaptchaRes>(
    `${SUB_URL}/recaptcha`,
    recaptchaToken,
  ).then((res) => res.data);
